import React, {Component} from "react";

import axios from 'axios';
import Constants from '../../../components/Constants/';
import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class Specialities extends Component {

  constructor(props) {
    super(props);

    this.refreshSpecialitiesList = this.refreshSpecialitiesList.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.onAddSpeciality = this.onAddSpeciality.bind(this);

    this.state = {
        specialitiesList: null,
        activePage: 1
      };

      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }

      this.refreshSpecialitiesList();
    }

    refreshSpecialitiesList(){
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/speciality'
      })
      .then(response => {
          this.setState({
              specialitiesList: response.data
          });
      });
    }

    statusFormatter(cell, row){
      return (
        cell == "ACTIVE" ? <Badge color="success">Ativo</Badge> : <Badge color="danger">Inativo</Badge>
      );
    }

    actionsFormatter(cell, row){
      return (
        <Button color="info" onClick={() => { alert(cell); }}><i className="fa fa-pencil"></i></Button>
      );
    }

    renderPaginationShowsTotal(start, to, total) {
      return (
        <p>
          Exibindo de { start } a { to }, total: { total }
        </p>
      );
    }

    afterSaveCell(row, cellName, cellValue) {
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/speciality',
          data: row
      })
      .then(response => {
        this.msg.show('Especialidade salva.', {
          time: 10000,
          type: 'success'
        });
      });
    }

    onAddSpeciality(row) {

      row.id = null;
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/speciality',
          data: row
      })
      .then(response => {
          this.msg.show('Especialidade adicionada.', {
            time: 10000,
            type: 'success'
          });
          this.refreshSpecialitiesList();
      });
    }

    createCustomModalHeader(closeModal, save){
      return (
        <InsertModalHeader
          className='model-header'
          title=''
         />
      );
    }


    render() {
      if(this.state.specialitiesList == null) return null;

      const tableOptions = {
        paginationSize: 10,
        hideSizePerPage: true,
        paginationShowsTotal: true,
        paginationShowsTotal: this.renderPaginationShowsTotal,
        onAddRow: this.onAddSpeciality,
        insertModalHeader: this.createCustomModalHeader
      };

      const statusTypes = [ {
        value: 'ACTIVE',
        text: 'Ativo'
      }, {
        value: 'INACTIVE',
        text: 'Inativo'
      }];

      const cellEdit = {
        mode: 'dbclick',
        blurToSave: true,
        afterSaveCell: this.afterSaveCell,
      };

      return(
          <div>
            <h2>Especialidades</h2>
            <hr />
            <BootstrapTable ref="table" data={this.state.specialitiesList} version='4'
              striped hover pagination insertRow search searchPlaceholder='Pesquisa Geral'
              options={tableOptions} cellEdit={ cellEdit }>
              <TableHeaderColumn dataField="description" dataSort={true} width='40%'>Descrição</TableHeaderColumn>
              <TableHeaderColumn dataField="status" editable={ { type: 'select', options: { values: statusTypes } } } dataFormat={this.statusFormatter} dataSort={true} width='25%'>Status</TableHeaderColumn>
              <TableHeaderColumn dataField="id" autoValue isKey={true} width='25%'>ID</TableHeaderColumn>

            </BootstrapTable>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default Specialities;



// WEBPACK FOOTER //
// ./src/views/admin/Speciality/Speciality.js